// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';

interface EditCommitteeAuditorFormDTO { 
  auditorId: number;
}
const EditCommitteeAuditorFormDTO = {
  create: (initValues?: Partial<EditCommitteeAuditorFormDTO> | Record<string, unknown> | null) => {
    return Object.assign(
    {
      auditorId: 0,
    },
    initValues);
  }
};

export default EditCommitteeAuditorFormDTO;